'use strict';

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ReactQuill from 'react-quill';
export default class TextEditor extends PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = value => {
    const component = this,
      props = this.props;

    // useless handleChange triggered by props state reset
    if (!props.value && value === '<p><br></p>') return;
    props.onChange({
      e: null,
      value: value,
      name: props.name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    const status = props.status[props.name] || {};
    const info = status.info ? /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg c-field-msg--green"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg__content"
    }, status.info)) : undefined;
    const error = status.error ? /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg c-field-msg--red"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg__content"
    }, status.error)) : undefined;
    const warning = status.warning ? /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg c-field-msg--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-field-msg__content"
    }, status.warning)) : undefined;
    let modules = {
      toolbar: [[{
        'header': [1, 2, false]
      }], [{
        align: ['justify', 'center', 'right']
      }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
        'list': 'ordered'
      }, {
        'list': 'bullet'
      }, {
        'indent': '-1'
      }, {
        'indent': '+1'
      }], ['link'], ['clean']]
    };
    if (props['without-headings']) {
      modules.toolbar.shift();
    }
    let formats = ['header', 'align', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'left', 'center', 'right', 'justify'];
    if (props.images) {
      formats.push('image');
      modules.toolbar[3].push('image');
    }
    if (props.wsiwg === false) {
      modules.toolbar = false;
    }
    const label = props.label ? /*#__PURE__*/React.createElement("div", {
      className: "form-custom-label"
    }, props.label) : undefined;
    const output = /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, label, error, warning, info, /*#__PURE__*/React.createElement(ReactQuill, {
      value: props.value,
      formats: formats,
      onChange: component.handleChange,
      modules: modules,
      readOnly: props['read-only']
    }));
    return output;
  }
}
TextEditor.propTypes = {
  wsiwg: PropTypes.bool,
  images: PropTypes.bool,
  'read-only': PropTypes.bool,
  'without-headings': PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  'default-value': PropTypes.string,
  status: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
TextEditor.defaultProps = {
  wsiwg: true,
  images: false,
  'without-headings': false
};
